export const SEARCH_PROVIDERS = ['xmlstock', 'yandex_search_api'] as const;
export type SearchProvider = (typeof SEARCH_PROVIDERS)[number];
export const SEARCH_PROVIDER_LABELS: Record<SearchProvider, string> = {
  xmlstock: 'XMLStock',
  yandex_search_api: 'Yandex Search API',
};

export const YANDEX_SEARCH_MODES = ['deferred', 'sync'] as const;
export type YandexSearchMode = (typeof YANDEX_SEARCH_MODES)[number];
export const YANDEX_SEARCH_MODE_LABELS: Record<YandexSearchMode, string> = {
  deferred: 'Отложенный',
  sync: 'Синхронный',
};
export function searchProviderLabel(config: {
  provider: SearchProvider;
  yandexSearchMode: YandexSearchMode;
}): string {
  return (
    SEARCH_PROVIDER_LABELS[config.provider] +
    (config.provider === 'yandex_search_api'
      ? ` · ${YANDEX_SEARCH_MODE_LABELS[config.yandexSearchMode]}`
      : '')
  );
}

export type YandexFallbackReason = 'async_http_429';
export const YANDEX_FALLBACK_LABELS: Record<YandexFallbackReason, string> = {
  async_http_429: 'Резерв: отложенный запрос вернул HTTP 429',
};
export function yandexCollectionLabel(
  mode: YandexSearchMode,
  reason?: YandexFallbackReason | null,
): string {
  return YANDEX_SEARCH_MODE_LABELS[mode] + (reason ? ` · ${YANDEX_FALLBACK_LABELS[reason]}` : '');
}
